<template>
  <div class="my_community_wrap" @scroll="handleScroll">
    <div class="search_input_wrap" >
      <van-field placeholder="手机号" class="search_input" v-model="tel" :maxlength="11" >
        <template #button>
          <div class="search" @click="handleSearch" ></div>
        </template>
      </van-field>
    </div>

    <div class="statistics_wrap" >
      <div class="statistics_item" >
        <div>{{ userCommunityInfoVo.allDirectCount }}</div>
        <div>社群人数</div>
      </div>

      <div class="statistics_item" >
        <div>{{ userCommunityInfoVo.dayDirectCount }}</div>
        <div>今日新增</div>
      </div>

      <div class="statistics_item" >
        <div>{{ userCommunityInfoVo.monthDirectCount }}</div>
        <div>本月新增</div>
      </div>
    </div>

    <div class="community_list" >
      <div class="community_item" v-for="(item, index) in list" :key="index" @click="subCommunity(item.userId, item.nickName)" >
        <div class="community_head" >
          <img :src="item.headImgUrl" />
          <div class="community_head_right" >
            <div>
              <div class="user_name" >{{ item.nickName }}</div>
<!--              <div class="vip" ></div>-->
              <img :src="level[item.level]" class="vip" />
            </div>
            <div>
              <div class="user_desc" >手机:{{ item.tel }}</div>
              <div class="user_desc" v-if="item.parentUserNickName" >邀请人: {{ item.parentUserNickName }}</div>
            </div>
          </div>
        </div>
        <div class="community_statistics" >
          <div class="community_statistics_item" >
            <div>消费额</div>
            <div>￥{{ item.consumption }}</div>
          </div>

          <div class="community_statistics_item" >
            <div>营业额</div>
            <div>￥{{ item.turnover }}</div>
          </div>

          <div class="community_statistics_item" >
            <div>直接营业额</div>
            <div>￥{{ item.directTurnover }}</div>
          </div>

          <div class="community_statistics_item" >
            <div>社群人数</div>
            <div>{{ item.directUserCommunityCount }}</div>
          </div>
        </div>

        <div class="register_time" >
          <div>注册时间：{{ item.createTime }}</div>
        </div>
      </div>
    </div>

    <van-empty description="暂无数据" v-if="!loading && list.length <= 0" />
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  getUserCommunityInfoVoByToken,
  getUserCommunityListVoByPageByToken
} from '@/api/community'
import vip from '../home/img/vip.png'
import shopkeeper from '../home/img/shopkeeper.png'
import tourist from '../home/img/tourist.png'
import partner from '../home/img/partner.png'
import ceo from '../home/img/ceo.png'
export default {
  name: 'myCommunity',
  data() {
    return {
      userCommunityInfoVo: {
        allDirectCount: 0,
        weekDirectCount: 0,
        monthDirectCount:0,
      },
      page: 1,
      pageSize: 10,
      tel: '',
      list: [],
      loading: false,
      level: {
        "-1": tourist,
        "0" : vip,
        "1" : shopkeeper,
        "2" : ceo,
        "3" : partner
      }
    }
  },
  methods: {
    handleScroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      console.log(scrollTop, clientHeight, scrollHeight)
      if (scrollTop + clientHeight >= scrollHeight - 50) { // -50  适配安卓
        this.page++
        this.getUserCommunityListVoByPageByToken()
      }
    },
    subCommunity(selectUserId, nickName) {
      this.$router.push({ name: 'subCommunity', params: { selectUserId, nickName } })
    },
    handleSearch() {
      this.page = 1
      this.list = []
      this.getUserCommunityListVoByPageByToken()
    },
    getUserCommunityInfoVoByToken() {
      getUserCommunityInfoVoByToken({}).then(res => {
        console.log(res)
        if(res.success) {
          this.userCommunityInfoVo = res.data
        }
      })
    },
    getUserCommunityListVoByPageByToken() {
      const { page, pageSize, tel } = this
      this.loading = true
      getUserCommunityListVoByPageByToken({ page, pageSize, tel }).then(res => {
        this.loading = false
        if(res.success) {
          this.list = this.list.concat(res.data)
        }
      })
    }
  },
  mounted() {
    this.getUserCommunityInfoVoByToken()
    this.getUserCommunityListVoByPageByToken()
  }
}
</script>
